import _ from "lodash";
import dayjs from "dayjs";

export default {
  install(Vue) {
    var data = {
      user:{},
      centro:{}
    }
    
    Vue.prototype.setData = (newData) => {
      data = {...data,...newData};
    }
    
    Vue.prototype.$d = () => {
      return data;
    }
    
    Vue.prototype.emptyFiles = (data) => {
        var aux = Vue.prototype.totalFiles(data);
        return aux[1] - aux[0];
    }

    Vue.prototype.generateNotification = (centroEmpresa,message) => {
        console.log(centroEmpresa,message);
    }

    Vue.prototype.calculateCircleDepth = (data, resta = 1) => {
        var result = data.depth - resta;
        if (result <= 0) result = 0;
        return result;
    }

    Vue.prototype.totalFiles = (data) => {
        var result = 0;
        var resultRecords = 0;
        let aux = null;

        if (data.data) {
            aux = Vue.prototype.totalFiles(data.data);
            result = result + aux[0];
            resultRecords = resultRecords + aux[1];
        }

        if (data.empleados) {
            aux = Vue.prototype.totalFiles(data.empleados);
            result = result + aux[0];
            resultRecords = resultRecords + aux[1];
        }

        // Si es iterable...
        if(Symbol.iterator in Object(data)) {
            for (const dat of data){
                if (dat.files && dat.files.length){
                    for (const file of dat.files){
                        result+=file.state ? 1 : 0;
                    }
                }
                if(!dat.opcional_por_defecto) resultRecords = resultRecords + (dat.allowFileUpload ? 1 : 0);
                if (dat.childs) {
                    aux = Vue.prototype.totalFiles(dat.childs);
                    result = result + aux[0];
                    resultRecords = resultRecords + aux[1];
                }
                if (dat.data) {
                    aux = Vue.prototype.totalFiles(dat.data);
                    result = result + aux[0];
                    resultRecords = resultRecords + aux[1];
                }
            }
        }

        return [result,resultRecords];
    }
    
    Vue.prototype.totalFilesRec = (records) => {
        var total1 = 0;
        var total2 = 0;
        for (const record of records){
            var aux = Vue.prototype.totalFiles(record.data);
            total1+=aux[0];
            total2+=aux[1];
        }
        return [total1,total2];
    }
  }
};
